module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2chap"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("PROLOGUE")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "chapsub"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Akutan Island, Gulf of Alaska")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The 130-foot research boat rocked back and forth in the frigid water as the sky darkened and the last remnants of dusk vanished. Rain fell nearly horizontally, battering everything it touched. An occasional wave from the winter storm crashed over the railing, spraying the deck with frost and foam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anchored only a few hundred yards off the north side of Akutan Island, its captain had wisely chosen to seek shelter as the gulf side of the island succumbed to a relentless pounding. Unfortunately for the crew, the storm wasn’t the only force of nature stalking the prototype research vessel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From a perch nestled among the nooks and crannies of several large, craggy rocks on the severe slope of a cliff, a pair of night-vision, military-grade binoculars was trained on the boat. Their owner stared through the lenses and looked at the illuminated dials on his watch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("A few more minutes and visibility will be less than twenty yards. Almost time to go.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("The team commander wasn’t comfortable on American soil, but his orders had been issued from the top of his chain of command, a chain that didn’t exist in any operational publication. His team operated ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("outside the conventional services which his country boasted and was only called upon to execute missions in the most extreme circumstances.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He didn’t question his orders. Assuming command of his elite team years ago, his first order of business had been the removal of all questions of morality and objectivity. The success of each individual mission was all that mattered, and he had yet to fail. Tonight would be no different.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were no signs of life on deck. The crew of six, including the captain and the two researchers, was riding out the storm below deck or in the wheelhouse. It was an advantage for him and his team—the weather would mask their movement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The commander spoke quietly in English into a slim, waterproof microphone that wrapped around from his ear to his mouth. “We go in two minutes. Conduct one last gear check to ensure no loose items. Radio silence until we make contact. And no matter what, the rules of engagement must be followed. No deviations.” He knew there wouldn’t be any, and although he’d never had to reiterate his instructions before, his superior had emphasized the point to him. Above all else, he followed his orders to the letter. “Wolverine, out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The rain gathered in intensity as the final vestiges of light slipped away. Moments later, four dark figures nimbly crept down the steep slope toward the churning water below. Wraiths in the night, they vanished into the gulf waters.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("———")]), _vm._v(" "), _c('p', {
    staticClass: "chapsub"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Onboard the oceanic research vessel")]), _vm._v(" "), _c('span', {
    staticClass: "txbfit"
  }, [_vm._v("Arctic Glide")])])]), _c('p', {
    staticClass: "noindenta"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("“Jack, how long is this shit supposed to last again? I thought I was getting used to this boat, but I guess not. I feel fucking awful,” said Colin Davies, a research scientist on loan to North American Oil. Rumor on the boat was that he was some sort of mad scientist for ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("the government, but he’d refused to confirm or deny it. He stood in the wheelhouse and tried to maintain his balance as the boat swayed back and forth.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A satisfied smirk spread across the captain’s face. He’d spent a lifetime in and around these waters. He never tired of watching a land walker—as he referred to anyone not from the Aleutian Islands—get seasick on his boat. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Although this baby isn’t really your boat now, is it, Jack?")]), _vm._v(" he told himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Supposed to pick up steam over the next twelve to eighteen hours. After that, should dramatically drop off in intensity. I’d say we’re back out in open water within twenty-four hours.” "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("And if it weren’t for your weak constitution, we’d still be out on the water")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After years of running a crab boat out of Dutch Harbor, Jack Dawson had retired, only to be hired by North American to skipper their latest research vessel built with cutting-edge oil and satellite exploration technology. It carried self-contained, stand-alone servers and closed networks. It was designed especially for these frigid waters, with a reinforced hull and a sloping bow to force ice down and away from the ship.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Its current mission was to test the communications, navigation, and satellite research capabilities onboard in all weather conditions. The captain knew that Colin Davies had developed some of the software—thus, his required presence—and he was also reported to be close friends with one of North American’s CEOs, which was why Jack enjoyed giving him so much grief. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("A land walker")]), _vm._v(" and "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("a suit in disguise.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Colin nodded and started to speak, but a sudden gust of wind rattled the wheelhouse as a wave crashed into the side. He slipped on the shifting floor. As he fell, he grabbed the back of the copilot’s chair. The chair turned on its pedestal and—as if mocking him—shook off his hand, spinning him to the deck. He slammed down on his haunches, his legs splayed out in front of him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jack laughed out load. “Are you having fun yet?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“Goddamnit!” Colin ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("shouted. He struggled to his feet. “I’m going down to the galley with Tom and the rest of the crew. Enjoy the storm.” As Jack watched in bemusement, Colin turned and carefully exited down the steep stairs from the bridge to the main deck.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Blessed silence,” he muttered to himself. He sat in his chair and stared out the window. Night had finally fallen. He watched the swirling rain envelop his boat. He turned around to look back at the stern, intending to confirm that the minisub had not shifted on the open deck aft of the wheelhouse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A sudden movement on the main deck just below his observation window caught his attention. He was certain he’d seen a dark figure vanish under the overhang near the hatch to the main structure. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Who the hell went outside on the deck without telling me?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Jack Dawson moved to the staircase, he heard the hatch open, followed by a loud whooshing as the wind fought to enter the boat. It was followed by a dull "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("thump")]), _vm._v(" as the hatch was secured behind the reckless crew member.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, which one of you guys is that?” he called out. “Next time you get suicidal and decide to take a stroll outside, you better friggin’ let me know, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You hear me down there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still no response.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sound of quickly moving soft footsteps echoed up the stairwell. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("What the hell?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jack walked over to the head of the stairs and peered into the darkness below. What he saw froze him in his tracks, and his mind took a snapshot in time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A black shadow in the shape of a man stood on the stairs, its right arm pointed accusatorily at him. The whites of the eyes blazed at Jack out of the darkness. But it wasn’t the eyes that grabbed Jack’s attention—it was the black pistol in the man’s hand, a menacing shape that ended in a long cylinder with a tiny opening. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Oh no . . .")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("He heard a soft "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("thwap")]), _vm._v(" as the weapon fired point-blank into his body. A heavy punch hit his chest, and he staggered backward, as much from the shock as from the pain. He fell against the stack of radio equipment behind his chair and slumped to the floor. As his attacker stood over him, Captain Jack Dawson’s last thought was "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Who the hell are you?")]), _vm._v(" And then . . . nothing.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018286a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 69
// module chunks = 0